import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header from "../Home/Header";

/* ================= CATEGORY & ACTIVITIES ================= */
const categoryActivities = {
  WarmUp: [
    { name: "Jumping Jacks", count: "2 min", link: "https://www.youtube.com/watch?v=c4DAnQ6DtF8" },
    { name: "Arm Circles", count: "20 reps", link: "https://www.youtube.com/watch?v=140RTNMciH8" },
    { name: "High Knees", count: "30 sec × 2", link: "https://www.youtube.com/watch?v=8opcQdC-V-U" },
  ],
  Yoga: [
    { name: "Push Ups", count: "12 × 3", link: "https://www.youtube.com/watch?v=IODxDxX7oi4" },
    { name: "Shoulder Press", count: "10 × 3", link: "https://www.youtube.com/watch?v=qEwKCR5JCog" },
    { name: "Bicep Curl", count: "12 × 3", link: "https://www.youtube.com/watch?v=ykJmrZ5v0Oo" },
  ],
};

const scheduleOptions = [
  "Beginner Plan",
  "Intermediate Plan",
  "Advanced Plan",
  "Full Body Plan",
  "Cardio Plan"
];


const DAYS = ["Beginner Day1","Beginner Day2","Beginner Day3","Intermedia","Friday","Saturday","Sunday"];

/* ================= COMPONENT ================= */
function ActivitySchedulePlan() {
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const [currentDay, setCurrentDay] = useState("");
  const [category, setCategory] = useState("");
  const [tempActivities, setTempActivities] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [scheduleName, setScheduleName] = useState("");

  /* ================= ADD DAY ================= */
  const addDay = () => {
    if (selectedDay && !selectedDays.includes(selectedDay)) {
      setSelectedDays([...selectedDays, selectedDay]);
      setSelectedDay("");
    }
  };

  /* ================= ACTIVITY SELECT ================= */
  const toggleActivity = (activity) => {
    setTempActivities((prev) =>
      prev.some((a) => a.name === activity.name)
        ? prev.filter((a) => a.name !== activity.name)
        : [...prev, activity]
    );
  };

  /* ================= ADD CATEGORY TO DAY ================= */
  const addCategoryToDay = () => {
    if (!currentDay || !category || tempActivities.length === 0) return;

    setSchedule((prev) => ({
      ...prev,
      [currentDay]: [...(prev[currentDay] || []), { category, activities: tempActivities }],
    }));

    setCategory("");
    setTempActivities([]);
  };

  /* ================= PDF ================= */
const generatePDF = () => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  selectedDays.forEach((day, index) => {
    if (index > 0) doc.addPage();

    /* ================= HEADER BACKGROUND ================= */
    doc.setFillColor(164, 90, 82); // #A45A52
    doc.rect(0, 0, pageWidth, 40, "F");

    /* ================= HEADER TEXT ================= */
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255);
    doc.text("Life Fitness Partner", 14, 18);

    doc.setFontSize(12);
    doc.setTextColor(255, 255, 255);
    doc.text("Workout Schedule Plan", 14, 27);

    // Show Schedule Name below title
    if (scheduleName.trim()) {
      doc.setFontSize(11);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "normal");
      doc.text(`Schedule: ${scheduleName}`, 14, 35);
    }

    /* ===== DAY TITLE ===== */
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    const dayY = scheduleName ? 45 : 40;
    doc.text(day, 14, dayY);

    let y = dayY + 6;

    /* ===== CONTENT ===== */
    (schedule[day] || []).forEach((item, i) => {
      // Category title background
      doc.setFillColor(233, 150, 122); // #E9967A
      doc.rect(14, y - 5, pageWidth - 28, 8, "F");

      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 0);
      doc.text(`${i + 1}. ${item.category}`, 16, y);
      y += 4;

      autoTable(doc, {
        startY: y,
        head: [["No", "Activity", "Count", "Link"]],
        body: item.activities.map((a, idx) => [
          idx + 1,
          a.name,
          a.count,
          a.link,
        ]),
        styles: {
          fontSize: 10,
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [251, 206, 177], // #FBCEB1
          textColor: 255,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 60 },
          2: { cellWidth: 25 },
          3: { cellWidth: 90 },
        },
      });

      y = doc.lastAutoTable.finalY + 6;
    });



    /* ================= FOOTER BACKGROUND ================= */
    doc.setFillColor(251, 206, 177); // #FBCEB1
    doc.rect(0, pageHeight - 55, pageWidth, 55, "F");

    /* ================= FOOTER TEXT ================= */
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0); // black
    doc.setFont("helvetica", "normal");

    const footerText = `
Designed by Coach Kanishka Wijewardhana

ADSSM | Sport Science & Management – University of Sri Jayewardenepura
CPET | CBT | CPN | CWLS – International Academy of Sport Science (IASS)
...........................................................
8+ Years Professional Experience in Fitness & Strength Coaching
Founder & Head Coach Life Fitness Partner Gym
    `;

    doc.text(footerText.trim(), 14, pageHeight - 42);

    /* ================= OPTIONAL: DIVIDER ================= */
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(0.5);
    doc.line(14, 38, pageWidth - 14, 38); // thin line under header
  });

  doc.save("Life_Fitness_Workout_Schedule.pdf");
};





  /* ================= UI ================= */
  return (
    <div className="dashboard">
      <Header />
      <div className="payment-container">
        <h2>Activity Schedule Plan</h2>

       <div className="payment-card">
         <label className="field-label">Schedule Name</label>
         <select
           className="form-input"
           value={scheduleName}
           onChange={(e) => setScheduleName(e.target.value)}
         >
           <option value="">-- Select Schedule --</option>
           {scheduleOptions.map((s) => (
             <option key={s} value={s}>{s}</option>
           ))}
         </select>
       </div>



        {/* Select Day */}
        <div className="payment-card">
         <label className="field-label">Select Day Split</label>
          <select value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}>
            <option value="">Select Day</option>
            {DAYS.map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>
         <div className="filter-buttons">
          <button onClick={addDay} className="btn btn-primary">Add Day</button>
          </div>
        </div>

        {/* Current Day */}
        <div className="payment-card">
        {selectedDays.length > 0 && (
          <select value={currentDay} onChange={(e) => setCurrentDay(e.target.value)}>
            <option value="">Select Day to Plan</option>
            {selectedDays.map((d) => (
              <option key={d}>{d}</option>
            ))}
          </select>
        )}
        </div>

        {/* Category */}

        {currentDay && (

          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Select Category</option>
            {Object.keys(categoryActivities).map((c) => (
              <option key={c}>{c}</option>
            ))}
          </select>
        )}


        {/* Activities */}
       {category && (
         <div className="payment-card activity-card">
           {categoryActivities[category].map((a) => {
             const index = tempActivities.findIndex(
               (t) => t.name === a.name
             );

             return (
               <label key={a.name} className="activity-item">
                 <input
                   type="checkbox"
                   checked={index !== -1}
                   onChange={() => toggleActivity(a)}
                 />

                 <span className="activity-name">
                   {a.name} <span className="activity-count">({a.count})</span>
                 </span>

                 {/* Selection order */}
                 {index !== -1 && (
                   <span className="activity-order">{index + 1}</span>
                 )}
               </label>
             );
           })}
         </div>
       )}


           <div className="filter-buttons">
        <button className="btn btn-primary" onClick={addCategoryToDay}>
          Add Activities
        </button>
        </div>


        {/* Preview */}
        {/* Preview */}
        <div className="payment-card">
          <h3>Preview</h3>

          {selectedDays.length === 0 && <p>No days selected</p>}

          {selectedDays.map((day) => (
            <div key={day} className="asp-preview-day">
              <h4>{day}</h4>

              {(schedule[day] || []).length === 0 && (
                <p className="muted">No activities added</p>
              )}

              {(schedule[day] || []).map((plan, i) => (
                <div key={i} className="asp-preview-category">
                  <strong>
                    {plan.category} ({plan.activities.length})
                  </strong>

                  <ul>
                    {plan.activities.map((a, idx) => (
                      <li key={idx}>
                        {idx + 1}. {a.name} — <span className="count">{a.count}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>

 <div className="filter-buttons">
        <button className="btn btn-primary" onClick={generatePDF}>
          Generate PDF
        </button>
      </div>
      </div>
    </div>
  );
}

export default ActivitySchedulePlan;
